import { render, staticRenderFns } from "./AddProcedure.vue?vue&type=template&id=36205844&scoped=true&"
import script from "./AddProcedure.vue?vue&type=script&lang=js&"
export * from "./AddProcedure.vue?vue&type=script&lang=js&"
import style0 from "./AddProcedure.vue?vue&type=style&index=0&id=36205844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36205844",
  null
  
)

export default component.exports